<div class="container-fluid">
  <div class="mct-flex mct-row mb-2">
    <h3>
      {{ 'events.settings.sponsors.title' | translate | titlecase }}
      <i class="pi pi-question-circle wc-help-icon ml-2" [title]="'events.settings.sponsors.sponsors-title-help' | translate"></i>
    </h3>
  </div>

  <p>
    <button app-add-button
      [disabled]="userAccessLevel < 2"
      [label]="'events.settings.sponsors.add-button-label' | translate | titlecase"
      (onClick)="newSponsor()"
    >
    </button>
  </p>

  <div class="my-4">
    <div [hidden]="!loadingSponsors" class="mct-flex mct-row mct-gap-10">
      <wl-busy [show]="loadingSponsors"></wl-busy>
      <span>{{ 'common.loading' | translate | titlecase }}...</span>
    </div>

    <div [hidden]="loadingSponsors || sponsors?.length" class="alert alert-info">
      <i class="pi pi-info-circle mr-2"></i>
      {{ 'events.settings.sponsors.no-sponsors' | translate | titlecase }}
    </div>

    <p [hidden]="loadingSponsors || !sponsors?.length" class="text-muted small">
      <i class="pi pi-info-circle mr-1"></i>
      {{ 'events.settings.sponsors.click-name-to-drag' | translate }}
    </p>
  </div>

  <table cdkDropList (cdkDropListDropped)="sorted($event)" class="table table-hover" [hidden]="loadingSponsors || !sponsors?.length">
    <thead>
      <tr>
        <th>{{ 'events.settings.sponsors.name-column-header' | translate | titlecase }}</th>
        <th style="width: 250px"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of sponsors" cdkDrag class="wc-movable-row">
        <td class="align-middle">
          <i class="pi pi-bars mr-3 text-muted" cdkDragHandle style="cursor: move"></i>
          <span class="font-weight-bold">{{ item.SponsorName }}</span>
        </td>
        <td class="text-right align-middle">
          <div class="btn-group mct-gap-5">
            <button
              pButton
              type="button"
              class="btn btn-default btn-sm"
              (click)="editSponsor(item.SponserId)"
              [disabled]="userAccessLevel < 2"
              icon="pi pi-pencil"
              [label]="'common.edit' | translate | titlecase"
              styleClass="p-button-sm"
            ></button>
            <button
              pButton
              type="button"
              class="btn btn-danger btn-sm"
              (click)="confirmDeleteSponsor(item.SponserId)"
              [disabled]="userAccessLevel < 2"
              icon="pi pi-trash"
              styleClass="p-button-sm p-button-danger"
            ></button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>

  <app-back-to-top></app-back-to-top>
</div>

<p-dialog
  #eventSponsorsModal
  modal="true"
  [(visible)]="showEditModal"
  [closable]="true"
  styleClass="atlas-dialog-l"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header">
    <h4 class="modal-title">{{ 'events.settings.sponsors.title' | translate | titlecase }}</h4>
  </ng-template>

  <div class="container-fluid">
    <div *ngIf="loadingSponsor.busy" class="py-5 text-center">
      <wl-busy [show]="loadingSponsor.busy"></wl-busy>
    </div>

    <div class="alert alert-danger" *ngIf="loadingSponsor.message && !loadingSponsor.success">
      {{ loadingSponsor.message }}
    </div>

    <div class="form-horizontal mt-3" *ngIf="!loadingSponsor.busy">
      <div class="form-group">
        <label class="col-sm-3 control-label">{{ 'events.settings.sponsors.profile-lookup-label' | translate | titlecase }}</label>
        <div class="col-sm-9">
          <wl-profile-selector
            required
            [(ngModel)]="selectedSponsor.ProfileId"
            [loadMinProfile]="false"
            (onProfileChanged)="sponsorProfileChanged($event)"
          >
          </wl-profile-selector>
        </div>
      </div>

      <div class="form-group">
        <label class="col-sm-3 control-label">{{ 'events.settings.sponsors.image-lookup-label' | translate | titlecase }}</label>
        <div class="col-sm-9">
          <wl-image-lookup name="image" [(ngModel)]="selectedSponsor.SponsorLogoUrl"></wl-image-lookup>
        </div>
      </div>

      <div class="form-group">
        <label class="col-sm-3 control-label">{{ 'events.settings.sponsors.name-label' | translate | titlecase }}</label>
        <div class="col-sm-9">
          <input class="form-control" type="text" [(ngModel)]="selectedSponsor.SponsorName" placeholder="Enter sponsor name" />
        </div>
      </div>

      <div class="form-group">
        <label class="col-sm-3 control-label">{{ 'events.settings.sponsors.message-label' | translate | titlecase }}</label>
        <div class="col-sm-9">
          <textarea class="form-control" rows="2" [(ngModel)]="selectedSponsor.SponsorMessage"></textarea>
        </div>
      </div>

      <div class="form-group">
        <label class="col-sm-3 control-label">{{ 'events.settings.sponsors.website-label' | translate | titlecase }}</label>
        <div class="col-sm-9">
          <div class="input-group">
            <span class="input-group-addon"><i class="pi pi-link"></i></span>
            <input class="form-control" type="url" [(ngModel)]="selectedSponsor.SponsorWebsite" placeholder="https://" />
          </div>
        </div>
      </div>

      <div class="form-group">
        <div class="col-sm-offset-3 col-sm-9">
          <div class="checkbox">
            <label>
              <p-checkbox binary="true" [(ngModel)]="selectedSponsor.HideSponsorOrgName" class="mr-2"></p-checkbox>
              {{ 'events.settings.sponsors.hide-sponsor-org-name-label' | translate | titlecase }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="alert alert-danger text-left" *ngIf="savingError">
      {{ savingError }}
    </div>
    <div class="mct-flex mct-row mct-gap-10">
      <wl-busy [show]="saving"></wl-busy>
      <button
        pButton
        type="button"
        class="btn btn-primary"
        (click)="saveSponsors()"
        [disabled]="saving"
        icon="pi pi-save"
        [label]="(saving ? 'common.saving' : 'common.save') | translate | titlecase"
      ></button>
      <button
        pButton
        type="button"
        class="btn btn-secondary"
        (click)="showEditModal = false"
        [disabled]="saving"
        icon="pi pi-ban"
        [label]="'common.cancel' | translate | titlecase"
      ></button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  #confirmDeleteEventSponsorsModal
  modal="true"
  [(visible)]="showDeleteModal"
  [closable]="false"
  styleClass="atlas-dialog-m"
  [focusOnShow]="false"
>
  <div class="text-center p-3">
    <i class="pi pi-exclamation-triangle text-danger" style="font-size: 3rem"></i>
    <p class="mt-3">{{ 'events.settings.sponsors.delete-confirm' | translate }}</p>
  </div>

  <ng-template pTemplate="footer">
    <div class="alert alert-danger text-left" *ngIf="deleteError">
      {{ deleteError }}
    </div>
    <div class="mct-flex mct-row mct-gap-10">
      <wl-busy [show]="deleting"></wl-busy>
      <button
        pButton
        type="button"
        class="btn btn-danger"
        (click)="deleteSponsor()"
        [disabled]="deleting"
        icon="pi pi-trash"
        [label]="(deleting ? 'common.deleting' : 'common.delete') | translate | titlecase"
      ></button>
      <button
        pButton
        type="button"
        class="btn btn-secondary"
        (click)="showDeleteModal = false"
        [disabled]="deleting"
        icon="pi pi-ban"
        [label]="'common.cancel' | translate | titlecase"
      ></button>
    </div>
  </ng-template>
</p-dialog>
